// @flow

import React from 'react';
import { defaultIconProps, type IconProps, IconSvgWrapper } from './base';

const ArrowUpIcon = (props: IconProps) => (
  <IconSvgWrapper {...props}>
    <path
      fill={props.color}
      d="M20.1456 16.7928C19.9547 16.7926 19.7717 16.7166 19.6368 16.5816L12.4248 9.36959C12.3691 9.31371 12.3029 9.26938 12.23 9.23913C12.1571 9.20889 12.0789 9.19332 12 9.19332C11.9211 9.19332 11.8429 9.20889 11.7701 9.23913C11.6972 9.26938 11.6309 9.31371 11.5752 9.36959L4.36321 16.5816C4.22673 16.7088 4.0462 16.778 3.85967 16.7747C3.67314 16.7714 3.49517 16.6959 3.36326 16.5639C3.23134 16.432 3.15578 16.2541 3.15249 16.0675C3.1492 15.881 3.21843 15.7005 3.34561 15.564L11.4912 7.41839C11.6262 7.28356 11.8092 7.20782 12 7.20782C12.1908 7.20782 12.3738 7.28356 12.5088 7.41839L20.6544 15.564C20.755 15.6647 20.8234 15.7929 20.8512 15.9325C20.8789 16.0721 20.8646 16.2167 20.8102 16.3482C20.7558 16.4797 20.6636 16.5921 20.5453 16.6712C20.427 16.7504 20.2879 16.7927 20.1456 16.7928Z"
    />
  </IconSvgWrapper>
);

ArrowUpIcon.defaultProps = defaultIconProps;

export default ArrowUpIcon;
